import { API } from "./API";


// TEST
export class DAO {

  static GetEndPoint<T>(type: { new(): T; }) {
    return "/api/dao/" + (type as any).END_POINT;
  }

  static async Select<T>(type: { new(): T; }, cond: string): Promise<T[]> {

    let api_rslt = await API.Call_RESTful("GET", DAO.GetEndPoint(type), { cond: cond }, undefined);

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }

  }

  static async FetchByGuid<T>(type: { new(): T; }, guid: string): Promise<T> {

    if (guid == null || guid === "") {
      return null as T;
    }

    let api_rslt = await API.Call_RESTful("GET", DAO.GetEndPoint(type) + "/" + guid, undefined, undefined);

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }

  }

  static async FetchBySerno<T>(type: { new(): T; }, serno: number): Promise<T> {

    let api_rslt = await API.Call_RESTful(
      "GET", DAO.GetEndPoint(type) + "/" + serno,
      {
        by_id: "1"// 用ID來撈
      },
      undefined
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }

  }


  static async Insert<T>(type: { new(): T; }, data: T): Promise<T> {

    let api_rslt = await API.Call_RESTful(
      "POST", DAO.GetEndPoint(type),
      {
        strict: "0",// 關閉嚴格模式，允許 Entity 有其他欄位
      },
      data
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async InsertOnly<T>(type: { new(): T; }, data: T, columns: string[]): Promise<T> {

    let api_rslt = await API.Call_RESTful(
      "POST", DAO.GetEndPoint(type),
      {
        strict: "0",// 關閉嚴格模式，允許 Entity 有其他欄位
        columns: JSON.stringify(columns)
      },
      data
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static GetId(data: any) {
    let by_id = "0";
    let id = undefined;

    if ((data as any).guid != null) {
      id = (data as any).guid;
      by_id = "0";
    } else if ((data as any).serno != null) {
      id = (data as any).serno;
      by_id = "1";
    } else {
      throw new Error("Update: 必須有 guid 或 serno !!!");// 或是用讀 endpoint 的方法讀取 id_name
    }

    return { id, by_id };
  }

  static async Update<T>(type: { new(): T; }, data: T): Promise<T> {

    const { id, by_id } = DAO.GetId(data);

    let api_rslt = await API.Call_RESTful(
      "PATCH", DAO.GetEndPoint(type) + "/" + id,
      {
        by_id: by_id,
        strict: "0",// 關閉嚴格模式，允許 Entity 有其他欄位
      },
      data
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async UpdateOnly<T>(type: { new(): T; }, data: T, columns: string[]): Promise<T> {

    const { id, by_id } = DAO.GetId(data);

    let api_rslt = await API.Call_RESTful(
      "PATCH", DAO.GetEndPoint(type) + "/" + id,
      {
        by_id: by_id,
        strict: "0",// 關閉嚴格模式，允許 Entity 有其他欄位
        columns: JSON.stringify(columns)
      },
      data
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(type, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }



  static async DeleteByGuid<T>(type: { new(): T; }, guid: string): Promise<number> {

    let api_rslt = await API.Call_RESTful("DELETE", DAO.GetEndPoint(type) + "/" + guid, undefined, undefined);

    if (api_rslt.code === API.CODE_OK) {
      return api_rslt.data;
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }

  }

  static async DeleteBySerno<T>(type: { new(): T; }, serno: number): Promise<number> {

    let api_rslt = await API.Call_RESTful(
      "DELETE", DAO.GetEndPoint(type) + "/" + serno,
      {
        by_id: "1"// 用ID來撈
      },
      undefined
    );

    if (api_rslt.code === API.CODE_OK) {
      return api_rslt.data;
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }

  }



}